import { useContext } from 'react';
import { BalanceContextValue } from 'src/components/selfService/common/Balance/balance.types';
import { BalanceContext } from 'src/components/selfService/common/Balance/context/BalanceProvider';

export const useBalanceContext = (): BalanceContextValue => {
  const context = useContext(BalanceContext);

  if (context === null) {
    throw new Error('useBalanceContext must be used within a BalanceProvider');
  }

  return context;
};
